import { httpBus } from '@/api/httpBus/index.js'

/**
 * 拼接 query string。
 * 与全局 tansParams 的区别：province 即使为空也保留 `province=`，
 * 因为后端要求该字段恒存在（tansParams 会把空串一并丢弃）。
 */
function buildQuery(params) {
  const ALWAYS_KEEP = ['province']
  return Object.keys(params)
    .filter((key) => {
      const value = params[key]
      if (ALWAYS_KEEP.includes(key)) return true
      return value !== null && value !== '' && typeof value !== 'undefined'
    })
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key] ?? '')}`)
    .join('&')
}

/**
 * 分页查询天气数据
 * @param {{ pageNum:number, pageSize:number, province:string, temperature:number|string, startDate:string, endDate:string, stationId?:number|string }} params
 * @returns {Promise<{ data: { rows: Array, total: number } }>}
 */
export function getWeatherData(params) {
  // 直接把 query 拼到 url 上、不传 params，绕开 bus.js 拦截器里的 tansParams
  return httpBus.request('get', `/schedule/job/weather/data/query?${buildQuery(params)}`)
}
